const telegramBaseUrl = process.env.REACT_APP_TELEGRAM_SERVER;
export default telegramBaseUrl;
